export function isProviderReady(assessment, provider) {
  return assessment?.provider_readiness?.[provider] === true
}

export function isProductComparisonReady(assessment) {
  return assessment?.product_comparison_ready === true
}

export function needsCompetitorConfirmation(assessment) {
  if (!assessment || assessment.status !== 'pending') return false

  const stage = assessment.processing_stage
  if (['competitor_comparison', 'provider_comparison', 'completed', 'failed'].includes(stage)) {
    return false
  }

  if (!isProviderReady(assessment, 'google_grounded')) return false
  if (isProductComparisonReady(assessment)) return false

  return true
}

export function canViewAnalyticsResults(assessment) {
  if (!assessment) return false
  if (assessment.status === 'completed') return true
  if (assessment.status === 'failed') return false

  if (needsCompetitorConfirmation(assessment)) return false

  // Primary analytics unlock after grounded query scoring + product comparison.
  // Service provider comparisons and non-grounded jobs continue in the background.
  if (assessment.analytics_ready === true) return true

  // Trust analytics_ready from the API for both first-time runs and Re-runs.
  // Only fall back to the product-comparison heuristic for legacy cached
  // responses that predate the field.
  if (assessment.analytics_ready == null) {
    return isProductComparisonReady(assessment)
  }

  return false
}

export function isPipelineBlocking(assessment) {
  if (!assessment) return true
  if (assessment.status === 'failed') return true
  if (assessment.status === 'completed') return false

  return !canViewAnalyticsResults(assessment)
}

export function assessmentNeedsPolling(assessment) {
  if (!assessment) return false
  if (assessment.status === 'failed' || assessment.status === 'completed') return false

  return !canViewAnalyticsResults(assessment)
}

export function analysisStageToTaskKey(processingStage, assessment) {
  if (needsCompetitorConfirmation(assessment)) {
    return 'review_competitors'
  }

  const stageToTaskKey = {
    confirm_competitors: 'review_competitors',
    persona_creation: 'persona_creation',
    confirm_personas: 'persona_creation',
    queries_generation: 'queries_generation',
    confirm_queries: 'queries_generation',
    confirm_provider_queries: 'queries_generation',
    competitor_comparison: 'competitor_comparison',
    query_execution: 'query_execution',
    query_scoring: 'query_scoring'
  }

  return stageToTaskKey[processingStage] || processingStage
}
